import React from 'react';
import { getAvailablePremiumLookupKeys } from '@app/common';
import { LookupKeyEnum } from '../defs/api';
import { BillingPeriod, getBillingPeriodByLookupKey } from '../models/functions/billing-period';

const defaultLookupKeys = getAvailablePremiumLookupKeys();
const PricingOfferContext = React.createContext<readonly string[]>(defaultLookupKeys);

export const PricingOfferProvider: React.FC<React.PropsWithChildren<{ lookupKeys?: string[] }>> = ({
    lookupKeys,
    children,
}) => <PricingOfferContext.Provider value={lookupKeys ?? defaultLookupKeys}>{children}</PricingOfferContext.Provider>;

export const useAvailableBillingPeriods = (): BillingPeriod[] => {
    const lookupKeys = React.useContext(PricingOfferContext);
    return lookupKeys
        .map((key) => getBillingPeriodByLookupKey(key as LookupKeyEnum))
        .filter((period): period is BillingPeriod => period !== null);
};
